<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qy3EBr/tc-custom/9781497635036.jpg?1702842817843" alt="This image is the cover for the book Tackling the Team, The Vassi Collection"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tackling the Team, The Vassi Collection
      </h1>
      <p class="bookDescription body article font2">
        <p>“I suppose I should have stuck it through until graduation if I hadn’t met Jeff. The only alternative was getting a job, and without a degree there weren't too many interesting possibilities. Also, on the basic level of material comfort, I didn’t have anything to complain about. The campus was extremely pretty. On the night I first saw Jeff I had been without sex for almost three months, and it was making me more than a little jittery. It may say sound unladylike to put it this way, but when he asked me to the party, all I could think was . . . ”<br/><br/> Read more of Julie Ann DeWitt’s scintillating tale, as told to Marco Vassi. <i>Tackling the Team</i> is one of Vassi’s most daring works, written in the voice of Julie Ann DeWitt (as told to Marco Vassi).</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marco Vassi
      </h2>
      
      <p class="authorDescription body article">Marco Vassi was, without a doubt, the foremost erotic writer of our generation. Praised by Norman Mailer, Kate Millett, Saul Bellow, and Gore Vidal, he was not only the ultimate sexual explorer, but a literary craftsman whose own life experiences became the stuff of his fiction&mdash;expanded, of course, by a grand imagination and a full sense of the absurd.<BR /><BR /> Tragically, Vassi died from pneumonia after he had contracted AIDS.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?89dba7b2